export default __webpack_public_path__ + "static/media/logoletras.097bb411.png";